import styled from 'styled-components';
import { marginReplacer, truncateWidth } from 'styles/utils';

const fontColor = {
  primary: 'wfBlack',
  secondary: 'wfBlue',
  tertiary: 'wfWhite',
  destructive: 'wfOrange',
  warning: 'wfYellow',
  success: 'wfGreen',
  minimal: 'wfGrey500',
};

export const HeadingStyled = styled.h1`
  margin: ${props => (props.margin ? marginReplacer(props.margin) : '0')};
  margin-right: ${({ theme, mr }) => theme[mr]};
  margin-left: ${({ theme, ml }) => theme[ml]};
  padding: 0;
  font-size: ${props => props.theme.font.size[props.size] || 'inherit'};
  font-weight: ${props => props.theme.font.weight[props.weight] || 'inherit'};
  color: ${props => props.theme.color[fontColor[props.variant]]};
  text-align: ${props => props.align || 'inherit'};
  text-transform: ${props => props.textTransform};
  text-decoration: ${props => props.textDecoration};
  ${props =>
    props.singleLine &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `};
  ${props => props.isTruncated && truncateWidth('100%')}
  > small {
    font-size: 100%;
    color: ${props => props.theme.color.wfGrey500};
  }
`;
